function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/nonIterableRest.js
// module id = 1311
// module chunks = 0